import { render, staticRenderFns } from "./RepeatStudentDialog.vue?vue&type=template&id=98402fe8&"
import script from "./RepeatStudentDialog.vue?vue&type=script&lang=ts&"
export * from "./RepeatStudentDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports